module.exports = __webpack_public_path__ + "img/bandeau_bienvenue.ab7bceb9.png";